import { PapScoreResult } from '../../components/flows/patientAssistance/PapScoring';
import { ActionType } from '../ActionTypes';
import { StoreAction } from '../Store';
import { PapState } from './PapState';

export type PapAction = {
  type: ActionType.SET_PAP_SCORE_RESULT;
  scoreResult: PapScoreResult;
};

export function papReducer(state: PapState, action: StoreAction): PapState {
  switch (action.type) {
    case ActionType.SET_PAP_SCORE_RESULT: {
      return { ...state, scoreResult: action.scoreResult };
    }
    default:
      return state;
  }
}
